































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'

@Component
export default class OrderColumnReferredBy extends Vue {
    @Prop({ required: true }) order!: Order

    get routeToDetail() {
        return {
            name: 'orders_detail',
            params: {
                orderId: this.order.id,
                contactId: this.order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }
}
